import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { SvgSelector } from '../../../assets/icons/svg-selector';
export const UserProfileHeader = ({ setAssignUser }) => {
    const { t } = useTranslation();
    return (_jsxs("div", { className: "flex items-center justify-between gap-[15px] p-5", children: [_jsx("button", { onClick: () => setAssignUser(false), children: _jsx(SvgSelector, { id: "back" }) }), _jsx("h3", { className: "text-sm leading-7 text-center text-[#3A4362]", children: t('common.profile') }), _jsx("span", {})] }));
};
